// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Book----authorPopular-module---container---qQ-MY","title":"src-components-Book----authorPopular-module---title---3TXyZ","details":"src-components-Book----authorPopular-module---details---lqUgk","imageContainer":"src-components-Book----authorPopular-module---imageContainer---3eF37","image":"src-components-Book----authorPopular-module---image---1NOrB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Book/authorPopular.module.css
// module id = 321
// module chunks = 35783957827783